<template>
  <div v-if="showDetails" class="flex items-start gap-4">
    <!-- Curve Features Box -->
    <div :class="['timeline-section-box text-xs text-gray-500', viewMode === 'curve' ? 'bg-blue-50' : 'bg-purple-50']">
      <!-- Curve Metrics -->
      <div v-if="viewMode === 'curve'" class="grid grid-cols-4 gap-2">
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Start</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.startFormatted || 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">End</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.endFormatted || 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Duration</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.duration != null ? curveData.duration.toFixed(1) + ' h' : 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Peak TAC</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.peak != null ? curveData.peak.toFixed(1) : 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Rise Duration</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.riseDuration != null ? curveData.riseDuration.toFixed(1) + ' h' : 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Rise Rate</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.riseRate != null ? curveData.riseRate.toFixed(2) : 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Fall Duration</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.fallDuration != null ? curveData.fallDuration.toFixed(1) + ' h' : 'N/A' }}</div>
        </div>
        <div class="text-center">
          <div class="font-medium text-gray-400 uppercase text-xs mb-1">Fall Rate</div>
          <div class="font-mono text-sm font-semibold">{{ curveData?.fallRate != null ? curveData.fallRate.toFixed(2) : 'N/A' }}</div>
        </div>
      </div>
      
      <!-- Day Metrics -->
      <div v-else-if="viewMode === 'day'">
        <DaySummary :day-data="dayData" :standalone="false" />
      </div>
    </div>
    
  </div>
</template>

<script>
import DaySummary from './DaySummary.vue'

export default {
  name: 'CurveFeatureSummary',
  components: {
    DaySummary
  },
  props: {
    // View mode: 'curve' or 'day'
    viewMode: {
      type: String,
      default: 'curve',
      validator: (value) => ['curve', 'day'].includes(value)
    },
    // Whether to show the details
    showDetails: {
      type: Boolean,
      default: true
    },
    // Curve data object (for curve mode)
    curveData: {
      type: Object,
      default: () => null
    },
    // Day data object (for day mode)
    dayData: {
      type: Object,
      default: () => null
    },
    // Session ID for API calls
    sessionId: {
      type: String,
      default: null
    },
    // Optional: specify which curve features to display
    enabledFeatures: {
      type: Array,
      default: () => [
        'start', 'end', 'duration', 'peak', 
        'riseDuration', 'riseRate', 'fallDuration', 'fallRate'
      ]
    },
    // Optional: specify which day features to display
    enabledDayFeatures: {
      type: Array,
      default: () => [
        'deviceOnDuration', 'deviceWornDuration', 'extremeNegativeDuration', 'date'
      ]
    }
  },
  data() {
    return {
    }
  },
  computed: {
    // Filter curve features based on enabledFeatures prop
    filteredCurveFeatures() {
      if (!this.curveData || !this.enabledFeatures) return {}
      
      const filtered = {}
      this.enabledFeatures.forEach(feature => {
        if (this.curveData.hasOwnProperty(feature)) {
          filtered[feature] = this.curveData[feature]
        }
      })
      return filtered
    },
    
    // Filter day features based on enabledDayFeatures prop
    filteredDayFeatures() {
      if (!this.dayData || !this.enabledDayFeatures) return {}
      
      const filtered = {}
      this.enabledDayFeatures.forEach(feature => {
        if (this.dayData.hasOwnProperty(feature)) {
          filtered[feature] = this.dayData[feature]
        }
      })
      return filtered
    }
  },
  methods: {
  }
}
</script>

<style scoped>
/* Consistent box styling for all timeline sections */
.timeline-section-box {
  background-color: #f9fafb; /* bg-gray-50 */
  padding: 1rem; /* p-4 */
  border-radius: 0.25rem; /* rounded */
  border: 2px solid #9ca3af; /* border-2 border-gray-400 */
  text-align: center;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px; /* Reduced height for more compact boxes */
}
</style>
